import axios from "axios";
import store from "store";
import router from "@/router";
import cookies from "js-cookie";
import _ from "lodash";

export default {
  clearAll() {
    store.clearAll();
  },
  loadShows({ getters, commit }) {
    axios
      .get(getters.showEndpoint, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        console.log(res);
        commit("setShows", res.data.results);
      });
  },
  loadShowDetails({ getters, commit }, id) {
    axios
      .get(`${getters.showEndpoint}${id}/`, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        console.log(res);
        commit("setCurrentId", id);
        commit("setShowDetails", res.data);
      });
  },
  loadUserData({ getters, commit }) {
    console.log("loadUserData");
    axios
      .get(getters.userEndpoint, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        console.log(res);
        commit("setUser", res.data.results[0]);
      });
  },
  newShow({ getters }) {
    var csrfToken = cookies.get("csrftoken");
    axios({
      method: "post",
      url: getters.showEndpoint,
      data: {
        user: 1
      },
      withCredentials: true,
      headers: {
        "X-CSRFToken": csrfToken,
        "Content-Type": "application/json"
      }
    })
      .then(function(response) {
        // Success, re-route to detail page.
        router.push({
          name: "detail",
          params: {
            id: response.data.id.toString()
          }
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  previewActiveShow({ state }) {
    // Open in a new window for now.
    router.push({
      name: "preview",
      params: {
        id: state.editingActiveShowId
      }
    });
    //var previewRoute = router.resolve({
    //  name: "preview",
    //  params:{
    //    id: state.editingActiveShowId
    //  }
    //});
    //window.open(previewRoute.href, "_blank");
  },
  updateCurrentShow({ getters, state }) {
    console.log("updateCurrentShow --> SERVER CALL");
    var csrfToken = cookies.get("csrftoken");
    axios({
      method: "patch",
      url: getters.showEndpoint + state.currentShowId + "/",
      data: {
        data: state.currentShowDetails.data
      },
      withCredentials: true,
      headers: {
        "X-CSRFToken": csrfToken,
        "Content-Type": "application/json"
      }
    })
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  createSlideArrayFromLibrary({ state, commit, dispatch }) {
    var showDetails = state.currentShowDetails;
    var images = showDetails.data.images;
    var duration = showDetails.data.audio.duration;
    var slideArray = _.map(images, (i, idx) => {
      return {
        file: i.filename,
        name: i.name,
        caption: "",
        timing: idx * (duration / images.length) * 1000
      };
    });
    showDetails.data.slideArray = slideArray;
    commit("setShowDetails", showDetails);
    dispatch("updateCurrentShow");
  }
};
